export const jobCount = () => {
  jobLists = document.querySelectorAll('.job-list');
  if (jobLists.length == 0) return;
  jobLists.forEach((list) => {
    if (list.children.length === 0) {
      list.closest('li').classList.add('hidden');
    }
  });
};
